export const toSkillLevelLabel = (skillLevel?: number): string =>
  skillLevel?.toString() ?? 'Not set'
